import { useState, useEffect } from "react";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { TwitchLive } from "@/components/TwitchLive";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { CompaniesSection } from "@/components/CompaniesSection";
import { FeaturedProjects } from "@/components/FeaturedProjects";
import { PortfolioSection } from "@/components/PortfolioSection";
import { ExperienceSection } from "@/components/ExperienceSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LandingPage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${API}/profile`);
        setProfile(response.data);
      } catch (e) {
        console.error("Failed to fetch profile:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground mono-label">Loading</p>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Failed to load profile data.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background relative">
      <div className="grid-overlay" />
      <Navbar profile={profile} />
      <main role="main">
        <HeroSection profile={profile} />
        <TwitchLive channel={profile.twitch_channel || "tylegn"} />
        <div className="section-glow-divider" aria-hidden="true" />
        <AboutSection profile={profile} />
        <div className="section-glow-divider" aria-hidden="true" />
        <CompaniesSection companies={profile.companies} />
        <div className="section-glow-divider" aria-hidden="true" />
        <FeaturedProjects projects={profile.featured_projects} />
        <div className="section-glow-divider" aria-hidden="true" />
        <PortfolioSection portfolio={profile.portfolio} />
        <div className="section-glow-divider" aria-hidden="true" />
        <ExperienceSection experience={profile.experience} />
        <div className="section-glow-divider" aria-hidden="true" />
        <ContactSection profile={profile} />
      </main>
      <Footer profile={profile} />
    </div>
  );
}
